<script setup>
import Icon from './Icon.vue';

defineOptions({ name: 'DsTabs' });

defineProps({
  modelValue: { type: [String, Number], default: null },
  items: { type: Array, default: () => [] },
  size: { type: String, default: 'md' }
});

defineEmits(['update:modelValue', 'change']);
</script>

<template>
  <div
    :class="['ds-tabs', `ds-tabs--${size}`]"
    role="tablist"
  >
    <button
      v-for="it in items"
      :key="it.value"
      role="tab"
      type="button"
      :aria-selected="modelValue === it.value"
      :class="['ds-tabs__tab', { 'is-active': modelValue === it.value }]"
      @click="$emit('update:modelValue', it.value); $emit('change', it.value)"
    >
      <Icon
        v-if="it.icon"
        :name="it.icon"
        :size="14"
      />
      {{ it.label }}
      <span
        v-if="it.count != null"
        class="ds-tabs__count"
      >{{ it.count }}</span>
    </button>
  </div>
</template>
